// extracted by mini-css-extract-plugin
export var box = "box-with-button-and-image-module--box--3uwqW";
export var button = "box-with-button-and-image-module--button--fQbVT";
export var buttonContainer = "box-with-button-and-image-module--button-container--C8sAb";
export var descriptionContainer = "box-with-button-and-image-module--description-container--e75uo";
export var firstRow = "box-with-button-and-image-module--first-row--8DiUA";
export var imageContainer = "box-with-button-and-image-module--image-container--0P3kL";